import React, {useEffect, useRef, useState} from 'react';
import {requestPOST} from 'src/utils/baseAPI';
import {Spin, Modal} from 'antd';
import moment from 'moment';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import './ContentStyle.css';
import {createReleaseNotesPath, createReleaseNotesPathAlpha} from 'src/utils/utils';

const initialMdModal = {open: false, title: '', content: '', loading: false};

const decodeMarkdown = async (response) => {
  const buffer = await response.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  let encoding = 'utf-8';
  let offset = 0;

  if (bytes[0] === 0xff && bytes[1] === 0xfe) {
    encoding = 'utf-16le';
    offset = 2;
  } else if (bytes[0] === 0xfe && bytes[1] === 0xff) {
    encoding = 'utf-16be';
    offset = 2;
  } else if (bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf) {
    offset = 3;
  } else {
    const sampleLength = Math.min(bytes.length, 200);
    let evenNullBytes = 0;
    let oddNullBytes = 0;

    for (let index = 0; index < sampleLength; index += 1) {
      if (bytes[index] === 0) {
        if (index % 2 === 0) {
          evenNullBytes += 1;
        } else {
          oddNullBytes += 1;
        }
      }
    }

    if (oddNullBytes > sampleLength / 5) {
      encoding = 'utf-16le';
    } else if (evenNullBytes > sampleLength / 5) {
      encoding = 'utf-16be';
    }
  }

  return new TextDecoder(encoding).decode(bytes.subarray(offset));
};

const ContentPage = (props) => {
  const [dataFiles, setDataFiles] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mdModal, setMdModal] = useState(initialMdModal);
  const [fileServerUpdates, setFileServerUpdates] = useState([]);
  const markdownRequestRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await requestPOST(`api/v1/downloads/getfile`, {
          path: props?.pathAbsolute + `\\\\${props?.type ?? 'beta'}`,
        });
        if (res) {
          setDataFiles(res ?? []);
        }
        setLoading(false);
        // setTimeout(() => {
        // }, 3000);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchData();

    return () => {};
  }, [props?.pathAbsolute, props?.type]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await requestPOST(`api/v1/downloads/getfileserver`, {
          path: 'C:\\ci-cd\\TDParking\\server\\update',
        });
        if (res) {
          setFileServerUpdates(res ?? []);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchData();

    return () => {};
  }, []);

  useEffect(() => {
    return () => markdownRequestRef.current?.abort();
  }, []);

  const openMdModal = async (mdPath, fileName) => {
    if (!mdPath) {
      setMdModal({
        open: true,
        title: `Mô tả - ${fileName}`,
        content: 'Không tìm thấy file mô tả cho phiên bản này.',
        loading: false,
      });
      return;
    }

    markdownRequestRef.current?.abort();
    const controller = new AbortController();
    markdownRequestRef.current = controller;

    setMdModal({
      open: true,
      title: `Mô tả - ${fileName}`,
      content: '',
      loading: true,
    });

    try {
      const url = `https://download.smartparking.vn/${mdPath}`;
      const res = await fetch(url, {signal: controller.signal});

      if (!res.ok) {
        throw new Error(`Không thể tải file Markdown (${res.status}).`);
      }

      const text = await decodeMarkdown(res);
      setMdModal({
        open: true,
        title: `Mô tả - ${fileName}`,
        content: text,
        loading: false,
      });
    } catch (error) {
      if (error.name !== 'AbortError') {
        setMdModal({
          open: true,
          title: `Mô tả - ${fileName}`,
          content: error.message || 'Không tải được nội dung mô tả.',
          loading: false,
        });
      }
    }
  };

  const closeMdModal = () => {
    markdownRequestRef.current?.abort();
    markdownRequestRef.current = null;
    setMdModal(initialMdModal);
  };

  return (
    <div className='container-download'>
      {loading && (
        <div className='container-spin'>
          <div id='loop' class='center'></div>
          <div id='bike-wrapper' class='center'>
            <div id='bike' class='centerBike'></div>
          </div>
          {/* <div class='lds-hourglass'></div> */}
        </div>
      )}
      {/* <div className='container-header'>
        <div class='waviy text-center'>
          <span style={{'--i': 1}}>S</span>
          <span style={{'--i': 2}}>M</span>
          <span style={{'--i': 3}}>A</span>
          <span style={{'--i': 4}}>R</span>
          <span style={{'--i': 5}}>T</span>
          <span style={{'--i': 6}}> </span>
          <span style={{'--i': 7}}>P</span>
          <span style={{'--i': 8}}>A</span>
          <span style={{'--i': 9}}>R</span>
          <span style={{'--i': 10}}>K</span>
          <span style={{'--i': 11}}>I</span>
          <span style={{'--i': 12}}>N</span>
          <span style={{'--i': 13}}>G</span>
        </div>
      </div> */}

      <div className='black-line'></div>

      <div className='container-content'>
        <ul className='list-item'>
          <li className='itemfile'>
            <span>Tên phần mềm</span>
            <span className='btn-down' aria-hidden='true' />
            <span style={{float: 'right', marginRight: '20px'}}>Kích thước</span>
            <span style={{float: 'right', marginRight: '20px'}}>Ngày tải lên</span>
          </li>
          {dataFiles &&
            dataFiles.map((item) => (
              <li className='itemfile' key={item?.path ?? item?.name}>
                <a
                  href={`https://download.smartparking.vn/${item?.path}`}
                  className='ahover'
                  download
                >
                  {item?.name}
                </a>
                <span style={{float: 'right', marginRight: '20px'}}>
                  {Math.round(item?.size / Math.pow(1024, 1))} MB
                </span>
                <span style={{float: 'right', marginRight: '20px'}}>
                  {moment(item?.createdOn).format('DD/MM/YYYY HH:mm')}
                </span>

                <button
                  type='button'
                  className='markdown-description-button ms-2'
                  onClick={() => {
                    const mdPath =
                      props?.type === 'alpha'
                        ? createReleaseNotesPathAlpha(item?.path)
                        : createReleaseNotesPath(item?.path);
                    openMdModal(mdPath, item?.name);
                  }}
                >
                  Mô tả
                </button>
                {fileServerUpdates &&
                  fileServerUpdates.some((obj) => item?.name?.includes(obj.originName)) && (
                    <span className='ms-2 text-danger'>
                      (Từ bản này trở đi phải update server 1 lần, update server xong nhớ chạy thử
                      file TD.HOST hoặc mở web 1 lần)
                    </span>
                  )}
              </li>
            ))}
        </ul>
      </div>
      <Modal
        className='release-notes-modal'
        open={mdModal.open}
        title={mdModal.title}
        onCancel={closeMdModal}
        footer={null}
        width={860}
        destroyOnClose
        bodyStyle={{maxHeight: '75vh', overflowY: 'auto'}}
      >
        {mdModal.loading ? (
          <div style={{textAlign: 'center', padding: '40px'}}>
            <Spin />
          </div>
        ) : (
          <div className='release-notes-content'>
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                a: ({node, children, ...linkProps}) => (
                  <a {...linkProps} target='_blank' rel='noreferrer noopener'>
                    {children}
                  </a>
                ),
              }}
            >
              {mdModal.content}
            </ReactMarkdown>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ContentPage;
